import React, { useEffect, useState } from 'react'
import { api, formatDateTime } from '../../utils'
import { notify } from '../../utils/notify'
import { Badge, Button, Table } from 'react-bootstrap'
import PageSelector from '../../components/PageSelector'
import Loading from '../../tagging_tool/components/Loading'
import { Link, useHistory } from 'react-router-dom'
import auth from '../../auth/service'
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap'
import ClienteSelect from '../../components/molecules/ClienteSelect'

const TableContext = React.createContext()
const PageContext = React.createContext()
const pageSize = 50
const displayColumns = ['id', 'name', 'cliente', 'url', 'active', 'crawler_status', 'email_frequency', 'created', 'actions']

function TableSiteUrls() {
  const {
    data, history, onSoftDelete
  } = React.useContext(TableContext)

  const crawler_status_variant = {
    ERROR: 'danger',
    READY_TO_ANALYZE: 'primary',
    RUNNING: 'warning',
    ANALYZED: 'success'
  }

  const formatColValues = (obj, colName, index) => {
    if (colName == 'id') {
      return (<td width="20" key={index}>{obj[colName]}</td>)
    }
    else if (colName == 'name') {
      return (
        <td key={index}>
          {obj.editable ? (
            <Link to={'/seo-sentinel/site-urls/edit/' + obj['id']}>
              <span>{obj[colName]}</span>
            </Link>
          ) : (
            <span>{obj[colName]}</span>
          )}
        </td>
      )
    }
    else if (colName == 'cliente') {
      return (
        <td key={index}>
          {obj[colName]?.nome || ''}
        </td>
      )
    }
    else if (colName == 'url') {
      return (
        <td key={index}>
          {obj[colName]}
        </td>
      )
    } else if (colName == 'active') {
      return (
        <td key={index}>
          <Badge pill variant={(obj[colName]) ? 'success' : 'warning'}>
            {(obj[colName]) ? 'ACTIVE' : 'INACTIVE'}
          </Badge>
        </td>
      )
    }
    else if (colName == 'crawler_status') {
      return (
        <td key={index}>
          <Badge pill variant={crawler_status_variant[obj[colName]]}>{obj[colName]}</Badge>
        </td>
      )
    }
    else if (colName == 'email_frequency') {
      return (
        <td key={index}>
          {obj[colName] == 'DAILY' ? (
            <Badge pill variant="info">{obj[colName]}</Badge>
          ) : (
            <Badge pill style={{ backgroundColor: '#fcf2b3', color: '#686016' }}>{obj[colName]}</Badge>
          )}
        </td>
      )
    }
    else if (colName == 'created') {
      return (
        <td key={index}>
          {formatDateTime(obj[colName])}
        </td>
      )
    }
    else if (colName == 'actions') {
      return (
        <td key={index}>
          <Button variant="danger"
            size="sm"
            onClick={() => history.push(`/seo-sentinel/alert-events/${obj['id']}`)}>
            Alerts
          </Button>
          {obj.editable && (
            <Button
              variant="outline-danger"
              size="sm"
              className="ml-2"
              onClick={() => onSoftDelete && onSoftDelete(obj['id'])}
            >
              Elimina
            </Button>
          )}
        </td>
      )
    }

    // else {
    //   return (<td key={index}>{obj[colName]}</td>)
    // }
  }

  if (data && data.length > 0) {
    return (
      <Table striped bordered hover>
        <thead>
          <tr>
            {displayColumns.map((k, thi) => <th key={thi}>{k}</th>)}
          </tr>
        </thead>
        <tbody>
          {data.map((d, i) => (
            <tr key={i}>
              {displayColumns.map((k, ii) => formatColValues(d, k, ii))}
            </tr>
          ))}
        </tbody>
      </Table>
    )
  }
  return null
}

function SiteUrlListTable() {
  const history = useHistory()

  const [siteUrls, setSiteUrls] = useState([])
  const [clienti, setClienti] = useState([])
  const [selectedClientId, setSelectedClientId] = useState('')
  const [appliedClientId, setAppliedClientId] = useState('')
  const [loading, setLoading] = useState(true)

  const [canPreviousPage, setCanPreviousPage] = useState(false)
  const [canNextPage, setCanNextPage] = useState(false)
  const [pageCount, setPageCount] = useState(0)
  const [pageIndex, setPageIndex] = useState(1)

  const getSiteUrls = (page = null, clienteId = appliedClientId) => {
    const params = {
      ...(page ? { page } : {}),
      ...(clienteId ? { cliente: clienteId } : {}),
    }

    api.get('/seo-sentinel/site-urls/', { params })
      .then(response => {
        setLoading(false)
        setCanPreviousPage(response.data?.previous != null)
        setCanNextPage(response.data?.next != null)
        setPageCount((response.data?.count) ? Math.ceil(response.data.count / pageSize) : 1)
        let reponseData = (response.data?.count) ? response.data.results : response.data
        reponseData = reponseData.map((obj) => {
          return {
            ...obj,
            'actions': ''
          }
        })
        setSiteUrls(reponseData)
      })
      .catch(err => {
        setLoading(false)
        console.error(err)
        notify(
          err,
          'error'
        )
      })
  }

  const getClienti = () => {
    if (!isWebranking) {
      setClienti([])
      return
    }
    api
      .get('/clienti/')
      .then((response) => {
        setClienti(Array.isArray(response.data) ? response.data : response.data?.results || [])
      })
      .catch((err) => console.error(err))
  }

  const handleSoftDelete = async (id) => {
    if (!window.confirm('Sei sicuro di voler eliminare questo sito?')) {
      return
    }

    try {
      await api.post(`/seo-sentinel/site-urls/${id}/soft-delete/`)
      setSiteUrls((prev) => prev.filter((item) => item.id !== id))
      notify('Sito eliminato con successo.', 'success')
    } catch (err) {
      notify(err?.response?.data?.error || 'Impossibile eliminare il sito.', 'error')
    }
  }

  const isWebranking = auth.userGroup === 'Webranking';

  const gotoPage = (page) => {
    setPageIndex(page)
  }
  const previousPage = () => {
    if (pageIndex > 1) {
      setPageIndex(pageIndex - 1)
    }
    else {
      setPageIndex(1)
    }
  }
  const nextPage = () => {
    setPageIndex(pageIndex + 1)
  }

  useEffect(() => {
    getClienti()
  }, [])

  useEffect(() => {
    setLoading(true)
    getSiteUrls(pageIndex, appliedClientId)
  }, [pageIndex, appliedClientId])

  const handleApplyFilters = () => {
    setLoading(true)
    setAppliedClientId(selectedClientId)
    setPageIndex(1)
  }

  const handleClearFilters = () => {
    setLoading(true)
    setSelectedClientId('')
    setAppliedClientId('')
    setPageIndex(1)
  }

  const icon = <i className="fa-solid fa-plus"></i>

  return (
    <Row style={{ marginBottom: "100px" }}>
      <div className="col pb-5">
        <Card className="bg-secondary shadow">
          <CardHeader className="bg-white border-0">
            <Row style={{ marginLeft: "0px" }}>
              <Col md={8}>
                <h1 className="mb-0">Site Urls</h1>
              </Col>
              {isWebranking && (<Col md={4} style={{ textAlign: "right" }}>
                <Button style={{ marginRight: "14px" }} variant="primary"
                  onClick={() => history.push('/seo-sentinel/site-urls/edit')} icon={icon}>
                  + Add new
                </Button>
              </Col>)
              }
            </Row>
          </CardHeader>
          <CardBody>
            {isWebranking && (
              <Row className="align-items-end mb-3">
                <Col md={4}>
                  <ClienteSelect
                    id="seo-sentinel-cliente-filter"
                    label="Cliente"
                    clienti={clienti}
                    selectedClientId={selectedClientId}
                    onChange={setSelectedClientId}
                    placeholder="Filtra per cliente"
                    isClearable
                  />
                </Col>
                <Col md={8} className="text-right pb-3">
                  <Button variant="light" className="mr-2" onClick={handleClearFilters}>
                    Clear Filters
                  </Button>
                  <Button variant="primary" onClick={handleApplyFilters}>
                    Apply
                  </Button>
                </Col>
              </Row>
            )}
            {(loading) ? (
              <Loading />
            ) : (
              <TableContext.Provider
                value={{
                  data: siteUrls,
                  history: history,
                  onSoftDelete: handleSoftDelete
                }}
              >
                <PageContext.Provider
                  value={{
                    gotoPage,
                    previousPage,
                    nextPage,
                    canPreviousPage,
                    canNextPage,
                    pageCount,
                    pageIndex,
                  }}
                >
                  <PageSelector context={PageContext} />
                </PageContext.Provider>

                <TableSiteUrls />

              </TableContext.Provider>
            )}
          </CardBody>
        </Card>
      </div>
    </Row>
  )
}
export default SiteUrlListTable
